module.exports = __webpack_public_path__ + "static/media/KW12_vystuz.de61b3ff.JPG";